// IMPORT REACT
import React from 'react';

// IMPORT STYLES
import { Alert } from './styles';


const YAAlert = (props) => {    
    return (
    	<Alert {...props} className={'alert-' + props.color}>
            {props.children}
        </Alert>
    )
    
}
export default YAAlert;